module.exports = __webpack_public_path__ + "static/media/logo.ea1b3936.svg";